import {api} from "@/api/apiHasData"
export const checkDataStatus=async function(type, no){
  let res= await api.hasData({type,no});
  if(res.data.code==200){
    return res.data.data.dataStatus //1正常，2下架，3删除
  }else{
    return ''
  }
}
export const checkDataStatusMessage=async function(type, no,fun){
  let res= await api.hasData({type,no});
  if(res.data.code==200){
    let type=res.data.data.dataStatus //1正常，2下架，3删除
    if(type!=1){
      this.$message.tipslist(`该数据已${['','','下架','删除'][type]}，点击确定后刷新列表。`,()=>{
        this.cardListCom&&this.cardListCom.getList&&this.cardListCom.getList()
        fun&&fun()
      })
    }
    return type
  }else{
    this.$message.error(`系统异常，请稍后再试`)
    return ''
  }
}
